import gql from 'graphql-tag'

export default gql`
  mutation updateAuthor ($id: Int!, $name: String, $details: [AuthorDetailInput]) {
    updateAuthor (input: { id: $id, name: $name, details: $details }) {
      id
      name
      details {
        id
        description
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
        language_code
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/author/update.js